module.exports = __webpack_public_path__ + "static/media/Soak.440cc005.svg";